import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.masterCatalog || initialState;

export const selectTests = createSelector(
  [selectDomain],
  (state) => state.tests
);

export const selectCommodityCategories = createSelector(
  [selectDomain],
  (state) => state.commodityCategories
);

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectTestCategories = createSelector(
  [selectDomain],
  (state) => state.testCategories
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectTestCount = createSelector(
  [selectDomain],
  (state) => state.testCount
);
